/**
 * Checks and generates url from host and path
 * @param {string} url host
 * @param {string} url path
 * @returns {Object}
 */
export function getUrl(host, path = '') {
    try {
        return new URL(path, host);
    } catch (e) {
        throwError(`Invalid host '${host}' or path '${path}'.`);
    }
}

/**
 * Generate url path from inputted ids
 * @param {string} url path
 * @param {string} url params
 * @returns {string}
 */
export function getFullPathString(urlPath, urlParams) {
    let params = '';
    if (Object.keys(urlParams).length) {
        params = `?${(new URLSearchParams(urlParams)).toString()}`;
    }

    const trimmedUrlPath = urlPath.replace(/^\//, '');
    const pathParts = ['', `${params}#`, trimmedUrlPath];
    return pathParts.join('/');
}

/**
 * Generates unique id hash
 * @returns {string}
 */
export function getUniqueId() {
    return Math.random().toString(36).substr(2, 10);
}

/**
 * Throws error with unified message
 */
export function throwError(message) {
    throw new Error(`CleverStories SDK: ${message}`);
}

/**
 * Check if url origins matches
 */
export function matchUrlOrigins(url1, url2) {
    return (new URL(url1).origin) === (new URL(url2).origin);
}

/**
 * Check if whitelabel logo source url is valid
 */
export function logoUrlSecurityCheck(logoUrl) {
    try {
        const { pathname, origin } = new URL(logoUrl);
        const splitPathname = pathname.split('.');
        const ext = splitPathname.length === 2 ? splitPathname[1] : '';
        return origin.match(/https:\/\/secure\.clevermaps\.io/i) &&
            pathname.startsWith('/whitelabeling') &&
            ['png', 'jpg', 'jpeg', 'svg'].includes(ext);
    } catch {
        return false;
    }
}
